var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainView",attrs:{"id":"mapView"}},[_c('left-col'),_c('choro-map')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }